import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { SupportedLanguageCodes } from "@skibro/types";
import { useTranslation } from "react-i18next";
import { FlagIcon } from "./FrontendUtils/FlagIcon";

interface Props {
  languageCode: SupportedLanguageCodes;
  onChange: (val: SupportedLanguageCodes) => void;
}

export const LanguageButtonGroup: React.FC<Props> = ({ onChange, languageCode }) => {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      value={languageCode}
      exclusive
      onChange={(_, val) => onChange(val)}
      sx={{ width: "100%", display: "flex" }}
    >
      <ToggleButton value="en" sx={{ flexGrow: 1 }}>
        <FlagIcon code="en" size="2em" />
      </ToggleButton>
      <ToggleButton value="fr" sx={{ flexGrow: 1 }}>
        <FlagIcon code="fr" size="2em" />
      </ToggleButton>
      <ToggleButton value="de" sx={{ flexGrow: 1 }}>
        <FlagIcon code="de" size="2em" />
      </ToggleButton>
      <ToggleButton value="it" sx={{ flexGrow: 1 }}>
        <FlagIcon code="it" size="2em" />
      </ToggleButton>
      <ToggleButton value="nl" sx={{ flexGrow: 1 }}>
        <FlagIcon code="nl" size="2em" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
